import { addEvent } from '@/api/userEvent'

export default {
  bind(el, binding) {
    const { arg, value } = binding
    if (arg !== 'change') {
      el.bindValue = value
      new Track().add(el, value, arg)
    }
  },
  componentUpdated(el, binding) {
    // 埋点类型
    // click:点击 dblclick:双击
    // change: 只针对下拉框 必须传params
    // focusout:取消焦点 focusin:进入焦点 针对输入框
    // 用法：v-track:click="{event_id:1, params: data}"
    const { arg, value, oldValue } = binding
    el.bindValue = value
    if (arg === 'change') {
      const oldParams = JSON.stringify(oldValue)
      const newParams = JSON.stringify(value)
      if (oldParams !== newParams) {
        new Track().userEvent(el, value)
      }
    } else {
      new Track().add(el, value, arg)
    }
  }
}

class Track {
  constructor(timeOut = 100) {
    this.timeOut = timeOut
  }
  add = (el, value, type) => {
    el.addEventListener(type, () => {
      this.userEvent(el, el.bindValue)
    })
  }

  userEvent = (el, event) => {
    const timeOut = 1000
    if (!el.disabled) {
      // 埋点处理方法
      (() => {
        addEvent(event)
      })()

      el.disabled = true
      setTimeout(() => {
        el.disabled = false
      }, timeOut)
    }
  }
}

